/**
 * FAQ content structure.
 *
 * Categories and questions are referenced by stable keys. The actual
 * copy lives in `src/translations/*.json` under `FAQPage.category.<categoryKey>.label`
 * and `FAQPage.qa.<questionKey>.question` / `.answer`, so it can be
 * overridden via Sharetribe Console hosted translations later.
 *
 * To add a new question:
 * 1. Add an entry to the `questions` array of the relevant category below.
 * 2. Add matching `FAQPage.qa.<key>.question` and `FAQPage.qa.<key>.answer`
 *    translation strings in the locale JSON files.
 */
const FAQ_CATEGORIES = [
  {
    key: 'rentingGear',
    questions: ['findGearNearMe', 'howToBookGear', 'paymentMethods'],
  },
  {
    key: 'listingGear',
    questions: ['howToListGear', 'howToGetPaid', 'gearDamage'],
  },
  {
    key: 'accountAndSafety',
    questions: ['createAccount', 'personalInfoSafe', 'identityVerification'],
  },
];

export default FAQ_CATEGORIES;
